import styled from "styled-components";

export const TimeSpentReminderMainTextBox = styled.div`
    display: flex;
    
    color: ${({theme}) => theme.colors.bodyText};
    font-size: 1.5rem;
    margin-top: 2rem;
     
    > span:nth-of-type(2) {
       color: ${props => props.theme.colors.popupIconColor};
       margin-left: 5px;
    }
    
    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.portrait}`} {
        flex-direction: column;
        
        > span:nth-of-type(2) {
            margin: 1rem 0;
        }
    }
`;
